import script from "./CalendarEventInfoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarEventInfoDialog.vue?vue&type=script&setup=true&lang=js"

import "./CalendarEventInfoDialog.vue?vue&type=style&index=0&id=8176b290&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8176b290"]])

export default __exports__